




















import Vue from 'vue'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'
import _ from 'lodash'
import moment from 'moment'
import { ChartNewInactiveClientsData } from '@/model/dashboard/ChartNewInactiveClientsData'

am4core.useTheme(am4themes_animated)

interface ComponentData {
  chart: any
  toggleButtons: number
  minYear: number
  maxYear: number
  selectedYear: number
  chartData: any | null
}

export default Vue.extend({
  name: 'LineChartNewInactiveClients',

  props: {
    chartNewInactiveClientsLabel: String,
    chartNewInactiveClientsDate: String,
    chartNewInactiveClientsCData: {
      type: Array as () => ChartNewInactiveClientsData[]
    },
  },

  data (): ComponentData {
    return {
      chart: undefined,
      toggleButtons: 0,
      minYear: parseInt(moment().format('YYYY')),
      maxYear: parseInt(moment().format('YYYY')),
      selectedYear: parseInt(moment().format('YYYY')),
      chartData: null
    }
  },

  watch: {
    toggleButtons (newVal: number): void {
      this.createChart()
    }
  },

  methods: {
    onBeforeClick (): void {
      this.selectedYear = this.selectedYear - 1
      this.createChart()
    },

    onNextClick (): void {
      this.selectedYear = this.selectedYear + 1
      this.createChart()
    },

    createChart (): any {
      //@ts-ignore
      let chart = am4core.create(this.$refs.columnChart, am4charts.XYChart)

      const data = [
          { "month": 1, "label": "01", "neukunden": null, "kundigungen": null },
          { "month": 2, "label": "02", "neukunden": null, "kundigungen": null },
          { "month": 3, "label": "03", "neukunden": null, "kundigungen": null },
          { "month": 4, "label": "04", "neukunden": null, "kundigungen": null },
          { "month": 5, "label": "05", "neukunden": null, "kundigungen": null },
          { "month": 6, "label": "06", "neukunden": null, "kundigungen": null },
          { "month": 7, "label": "07", "neukunden": null, "kundigungen": null },
          { "month": 8, "label": "08", "neukunden": null, "kundigungen": null },
          { "month": 9, "label": "09", "neukunden": null, "kundigungen": null },
          { "month": 10, "label": "10", "neukunden": null, "kundigungen": null },
          { "month": 11, "label": "11", "neukunden": null, "kundigungen": null },
          { "month": 12, "label": "12", "neukunden": null, "kundigungen": null }
      ]

      if(this.chartData[this.selectedYear]) {

        chart.data = data.map((item: any) => {
          this.chartData[this.selectedYear].forEach((i: ChartNewInactiveClientsData) => {
            if (i.month === item.month) {
              if (i.neu === 0) {
                item.kundigungen = i.sum
              } else if (i.neu === 1) {
                item.neukunden = i.sum
              }
            }
          })

          return item
        })

        if (this.toggleButtons === 1) {
          let q: any[] = []
          chart.data.forEach((item: any, index: number) => {
            if (index < 3) {
              if (q[0]) {
                q[0].neukunden = item.neukunden ? q[0].neukunden ? q[0].neukunden + item.neukunden : item.neukunden : q[0].neukunden
                q[0].kundigungen = item.kundigungen ? q[0].kundigungen ? q[0].kundigungen + item.kundigungen : item.kundigungen : q[0].kundigungen
              } else {
                item.month = ''
                item.label = 'Q1'
                q.push(item)
              }
            } else if (index < 7) {
              if (q[1]) {
                q[1].neukunden = item.neukunden ? q[1].neukunden ? q[1].neukunden + item.neukunden : item.neukunden : q[1].neukunden
                q[1].kundigungen = item.kundigungen ? q[1].kundigungen ? q[1].kundigungen + item.kundigungen : item.kundigungen : q[1].kundigungen
              } else {
                item.month = ''
                item.label = 'Q2'
                q.push(item)
              }
            } else if (index < 9) {
              if (q[2]) {
                q[2].neukunden = item.neukunden ? q[2].neukunden ? q[2].neukunden + item.neukunden : item.neukunden : q[2].neukunden
                q[2].kundigungen = item.kundigungen ? q[2].kundigungen ? q[2].kundigungen + item.kundigungen : item.kundigungen : q[2].kundigungen
              } else {
                item.month = ''
                item.label = 'Q3'
                q.push(item)
              }
            } else {
              if (q[3]) {
                q[3].neukunden = item.neukunden ? q[3].neukunden ? q[3].neukunden + item.neukunden : item.neukunden : q[3].neukunden
                q[3].kundigungen = item.kundigungen ? q[3].kundigungen ? q[3].kundigungen + item.kundigungen : item.kundigungen : q[3].kundigungen
              } else {
                item.month = ''
                item.label = 'Q4'
                q.push(item)
              }
            }
          })

          chart.data = q
        }
      } else {
        chart.data = data
      }

      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis())
      categoryAxis.dataFields.category = "label"
      categoryAxis.renderer.grid.template.location = 0
      categoryAxis.renderer.minGridDistance = 20

      chart.yAxes.push(new am4charts.ValueAxis())

      // Create series
      function createSeries(field: any, name: any, color: any) {
        let series: any = chart.series.push(new am4charts.LineSeries())
        series.dataFields.valueY = field
        series.dataFields.categoryX = "label"
        series.name = name
        series.tooltipText = "{valueY}"
        series.strokeWidth = 5
        if(color) {
          series.stroke = am4core.color(color)
        }

        let bullet: any = series.bullets.push(new am4charts.CircleBullet())
        bullet.circle.stroke = am4core.color("#fff")
        bullet.circle.strokeWidth = 1
        if(color) {
          bullet.fill = am4core.color(color)
        }

        return series
      }

      createSeries("neukunden", "Neukunden", "#03b237")
      createSeries("kundigungen", "Kündigungen", "#FF0000")

      chart.legend = new am4charts.Legend()
      chart.cursor = new am4charts.XYCursor()
      chart.zoomOutButton.disabled = true
    }
  },

  mounted () {
    this.chartData = _.groupBy(this.chartNewInactiveClientsCData, 'year')

    const years = Object.keys(this.chartData).map(Number)
    this.minYear = Math.min(...years)

    this.createChart()
  },

  beforeDestroy () {
    if (this.chart) {
      this.chart.dispose()
    }
  }
})
